import React from 'react';
import { XIcon } from 'lucide-react';
export function PainSection() {
  return <section className="py-16 px-4 bg-white border-t border-gray-100" data-id="element-129">
      <div className="max-w-3xl mx-auto" data-id="element-130">
        <div className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-131">
          <p data-id="element-132">Sé exactamente cómo te sentís.</p>

          <p data-id="element-133">Son las 7 de la mañana y ya estás agotada.</p>

          <p data-id="element-134">
            El nene no quiere levantarse. La nena llora porque el vaso no es el
            rosa. Y vos... ya empezaste el día sintiéndote como si hubieras
            perdido una batalla que ni siquiera empezó.
          </p>

          <p data-id="element-135">Intentás hablar tranquila. Respirás. Contás hasta tres.</p>

          <p data-id="element-136">
            Y de repente...{' '}
            <strong className="text-red-600 text-2xl" data-id="element-137">explotás.</strong>
          </p>

          <p data-id="element-138">
            Y después viene lo peor:{' '}
            <strong className="text-gray-900" data-id="element-139">la culpa.</strong>
          </p>

          <div className="bg-slate-50 p-6 rounded-xl border-l-4 border-slate-300 my-8 space-y-4 italic text-gray-600" data-id="element-140">
            <p data-id="element-141">"No tendría que haberle gritado así."</p>
            <p data-id="element-142">"¿Por qué no puedo controlarme?"</p>
            <p data-id="element-143">"¿Qué clase de mamá soy?"</p>
          </div>

          <p data-id="element-144">Esa voz en tu cabeza que no para.</p>

          <div className="my-16 text-center" data-id="element-145">
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-6" data-id="element-146">
              ¿Y si te dijera que el problema no sos vos?
            </h2>
            <p className="text-xl" data-id="element-147">
              El problema es que nadie te enseñó una herramienta real para ese
              momento. Una que funcione cuando estás al límite, sin dormir, con
              mil cosas en la cabeza y dos nenes tironeándote del brazo.
            </p>
            <p className="text-2xl font-bold text-green-600 mt-8 bg-green-50 inline-block px-6 py-3 rounded-lg" data-id="element-148">
              Eso es exactamente lo que el MÉTODO CALMA® te da.
            </p>
          </div>

          <div className="bg-red-50 rounded-2xl p-8 md:p-10 my-12 border border-red-100" data-id="element-149">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-150">
              El problema no es que seas mala mamá. Es que nadie te dio las
              herramientas correctas.
            </h3>

            <ul className="space-y-4 mb-8" data-id="element-151">
              <li className="flex items-start gap-3" data-id="element-152">
                <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-153" />
                <span data-id="element-154">
                  Probaste respirar profundo. <strong data-id="element-155">No alcanzó.</strong>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-156">
                <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-157" />
                <span data-id="element-158">
                  Probaste ignorar la rabieta. <strong data-id="element-159">Empeoró.</strong>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-160">
                <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-161" />
                <span data-id="element-162">
                  Probaste el tiempo fuera. <strong data-id="element-163">Lloró más fuerte.</strong>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-164">
                <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-165" />
                <span data-id="element-166">
                  Probaste hablar tranquila.{' '}
                  <strong data-id="element-167">Te salió gritando igual.</strong>
                </span>
              </li>
            </ul>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-red-100" data-id="element-168">
              <p className="font-bold text-xl text-gray-900 mb-4 text-center" data-id="element-169">
                Y lo peor no es el grito. Lo peor es lo que sentís después.
              </p>
              <p className="text-gray-700 text-center" data-id="element-170">
                Esa mezcla de culpa, agotamiento y miedo de estar fallando. Esa
                sensación de que tus hijos merecen una versión de vos que no
                podés sostener sola.
              </p>
              <p className="text-center text-xl mt-6" data-id="element-171">
                No es falta de amor.{' '}
                <strong className="text-red-600" data-id="element-172">
                  Es falta de un sistema.
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}